/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsOsvVulnerabilityAffectedDetails {
    getFixupPrototypeFunction() { return AppSecopsOsvVulnerabilityAffectedDetails.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsOsvVulnerabilityAffectedDetails>): AppSecopsOsvVulnerabilityAffectedDetails {
        let obj = Object.assign(new AppSecopsOsvVulnerabilityAffectedDetails(), model);
        AppSecopsOsvVulnerabilityAffectedDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsOsvVulnerabilityAffectedDetails>): AppSecopsOsvVulnerabilityAffectedDetails {
        if (!model) return null;
        return AppSecopsOsvVulnerabilityAffectedDetails.newInstance(<AppSecopsOsvVulnerabilityAffectedDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsOsvVulnerabilityAffectedDetails) {
        if (!obj) return;

        models.AppSecopsOsvVulnerabilityAffectedDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsOsvVulnerabilityAffectedDetails): boolean {
        Object.setPrototypeOf(obj, AppSecopsOsvVulnerabilityAffectedDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.package) {
            models.AppSecopsOsvVulnerabilityAffectedPackageDetails.fixupPrototype(this.package);
        }
        if (this.ranges) {
            for (let val of this.ranges) {
                models.AppSecopsOsvVulnerabilityVersionDetail.fixupPrototype(val);
            }
        }
    }

    package: models.AppSecopsOsvVulnerabilityAffectedPackageDetails;

    ranges: Array<models.AppSecopsOsvVulnerabilityVersionDetail>;

}
